import { render, staticRenderFns } from "./EditWarehouseModal.vue?vue&type=template&id=28678eff&scoped=true&"
import script from "./EditWarehouseModal.vue?vue&type=script&lang=js&"
export * from "./EditWarehouseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28678eff",
  null
  
)

export default component.exports